

//copy
function copyText(el, text) {
    navigator.clipboard.writeText(text).then(() => {
        const originalText = el.textContent;  // 保存原始文本
        el.textContent = 'copied';            // 修改为 copied
        setTimeout(() => {
            el.textContent = originalText;    // 2 秒后恢复
        }, 3000);
    })
}


var wFlag = window.innerWidth>750
$(()=>{

    $('.box1_btn').click(function(){
        var element = document.querySelector(".box2");
        element.scrollIntoView({block: "start",behavior: "smooth",});
    })

    var showFlag = false
    $('.brc_left span').click(function(){
        if(wFlag){
            if(!showFlag){
                $('.rule_show').fadeIn()
                $(this).text('Show less')
                showFlag = true;
                return;
            }else{
                $('.rule_show').fadeOut()
                $(this).text('Show the rule')
                showFlag = false;
                return;
            }
        }else{
            if(!showFlag){
                $('.Mbox_rule').css({height:'530px'})
                $(this).text('Show less')
                showFlag = true;
                return;
            }else{
                $('.Mbox_rule').css({height:'170px'})
                $(this).text('Show the rule')
                showFlag = false;
                return;
            }
        }
    })

    if(wFlag){
        new Swiper('.box4Swiper', {
            //autoplay: true,
            slidesPerView : 2.5,
            navigation: {
                nextEl: '.box4Swiper-button-next',
                prevEl: '.box4Swiper-button-prev',
            },
        })
    }

    $('.op_close').click(function(){
        $('.offPopus').fadeOut()
    })

    $('.box2_off').click(function(){
        $('.offPopus').fadeIn()
    })

    $('.opBtn').click(function(){
        $('.offPopus').fadeOut()
        box2Data.$data.popusFlag=true
    })

    $('.box4_left div span').click(function(){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SZUwHN']);
    })
})


var box2Data = new Vue({
    el: '.box2',
    data() {
        return {
            navIndex: 0,
            maxNormal: 5, // 普通物品最多5个
            zIndexNum: 10,
            recommendedIniu: "",
            suggestedIniu: '',
            hasDroppedIniu: false,
            previewImg: '',
            resFlag: false,
            iniuData: localStorage.getItem('recommendedIniu') || '',
            isMobile: false,
            popusFlag:false,
            tips:'Drag up to 5 items into the bag! Double-clicking an item will remove it from your bag.',
            itemMeta: {
                Umbrella: { volume: 25, shape: "Bulky" },
                Tumbler: { volume: 20, shape: "Bulky" },
                Novel: { volume: 30, shape: "Bulky" },
                Shades: { volume: 15, shape: "Bulky" },
                Key: { volume: 10, shape: "Bulky" },

                Notebook: { volume: 12, shape: "Slim" },
                Laptop: { volume: 15, shape: "Slim" },
                Airpods: { volume: 8, shape: "Slim" },
                Pen: { volume: 3, shape: "Slim" },
                Hand_Cream: { volume: 5, shape: "Slim" },
                Claw_Clip: { volume: 2, shape: "Slim" },
                Wallet: { volume: 10, shape: "Slim" }
            }
        }
    },
    watch: {
        // 切换导航，重置拖拽系统状态
        navIndex() {
            this.$nextTick(() => {
                this.recommendedIniu = "";
                this.initDragSystem();
            });
        }
    },
    methods: {
        // 下载图片相关方法
        loadImage(src) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = src;
            });
        },
        drawRoundRect(ctx, x, y, width, height, radius) {
            const r = Math.min(radius, width / 2, height / 2);

            ctx.moveTo(x + r, y);
            ctx.lineTo(x + width - r, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + r);
            ctx.lineTo(x + width, y + height - r);
            ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
            ctx.lineTo(x + r, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - r);
            ctx.lineTo(x, y + r);
            ctx.quadraticCurveTo(x, y, x + r, y);
        },
        async downloadComposedImage() {
            var that = this
            try {
                const wrap = this.$el.querySelector('.box2i_right');
                const bgEl = this.$refs.rightBg;
                const maskEl = this.$refs.maskImg;

                if (!wrap || !bgEl) {
                    // 图片区域不存在
                    return;
                }

                const wrapRect = wrap.getBoundingClientRect();
                const bgRect = bgEl.getBoundingClientRect();

                const scale = 2;
                const canvas = document.createElement('canvas');
                canvas.width = Math.round(wrapRect.width * scale);
                canvas.height = Math.round(wrapRect.height * scale);

                const ctx = canvas.getContext('2d');
                ctx.scale(scale, scale);

                // 透明底；如果你想白底可改成 fillRect
                ctx.clearRect(0, 0, wrapRect.width, wrapRect.height);

                // 1. 画底图
                const bgImg = await this.loadImage(bgEl.currentSrc || bgEl.src);
                ctx.drawImage(
                    bgImg,
                    bgRect.left - wrapRect.left,
                    bgRect.top - wrapRect.top,
                    bgRect.width,
                    bgRect.height
                );

                // 2. 画叠加图（带圆角和边框）
                if (this.previewImg && maskEl) {
                    const maskRect = maskEl.getBoundingClientRect();
                    const maskImg = await this.loadImage(maskEl.currentSrc || maskEl.src);

                    const x = maskRect.left - wrapRect.left;
                    const y = maskRect.top - wrapRect.top;
                    const w = maskRect.width;
                    const h = maskRect.height;
                    const radius = that.isMobile?10:32;

                    // 圆角裁剪
                    ctx.save();
                    ctx.beginPath();
                    this.drawRoundRect(ctx, x, y, w, h, radius);
                    ctx.closePath();
                    ctx.clip();

                    // 画 mask 图片
                    ctx.drawImage(maskImg, x, y, w, h);

                    ctx.restore();

                    // 画边框
                    ctx.beginPath();
                    this.drawRoundRect(ctx, x, y, w, h, radius);
                    ctx.closePath();
                    ctx.strokeStyle = '#000';
                    ctx.lineWidth = 1 / scale; // 保持接近 CSS 的 1px
                    ctx.stroke();
                }

                // 3. 下载
                const link = document.createElement('a');
                link.download = "My_Mother's_Day_Gift.png";
                link.href = canvas.toDataURL('image/png');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                showMessage('Download successful', 'success')

            } catch (err) {
                console.error('Save error:', err);
                showMessage('Save error', 'error')
            }
        },

        //拖拽结果显示到最终页相关方法
        captureBox() {
            requestAnimationFrame(() => {
                const root = this.$el;
                const box = root.querySelector('.box2_border');
                if (!box) return;

                const boxRect = box.getBoundingClientRect();

                const canvas = document.createElement('canvas');
                const scale = 2;
                canvas.width = Math.round(boxRect.width * scale);
                canvas.height = Math.round(boxRect.height * scale);

                const ctx = canvas.getContext('2d');
                ctx.scale(scale, scale);
                ctx.clearRect(0, 0, boxRect.width, boxRect.height);

                const tasks = [];

                const activeBagImg =
                    box.querySelector('.swiper-slide-active .box2s_img img:not([style*="display: none"])') ||
                    box.querySelector('.swiper-slide-active .box2s_img img');

                if (activeBagImg) {
                    tasks.push(this.drawDomImageToCanvas(ctx, activeBagImg, boxRect));
                }

                const items = box.querySelectorAll('.drag-item');
                items.forEach((imgEl) => {
                    tasks.push(this.drawDomImageToCanvas(ctx, imgEl, boxRect));
                });

                Promise.all(tasks).then(() => {
                    const tipEl = box.querySelector('.dragTips');
                    if (tipEl) {
                        this.drawTextToCanvas(ctx, tipEl, boxRect);
                    }

                    this.previewImg = canvas.toDataURL('image/png');
                }).catch((err) => {
                    console.error('error:', err);
                });
            });
        },
        drawTextToCanvas(ctx, textEl, boxRect) {
            const rect = textEl.getBoundingClientRect();
            const style = window.getComputedStyle(textEl);

            const x = rect.left - boxRect.left;
            const y = rect.top - boxRect.top;

            ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
            ctx.fillStyle = style.color || '#000';
            ctx.textBaseline = 'top';

            const text = textEl.textContent.trim();
            ctx.fillText(text, x, y);
        },
        drawDomImageToCanvas(ctx, imgEl, boxRect) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.src = imgEl.currentSrc || imgEl.src;

                img.onload = () => {
                    const rect = imgEl.getBoundingClientRect();

                    const x = rect.left - boxRect.left;
                    const y = rect.top - boxRect.top;
                    const w = rect.width;
                    const h = rect.height;

                    ctx.drawImage(img, x, y, w, h);
                    resolve();
                };

                img.onerror = reject;
            });
        },

        // 拖拽元素相关方法
        initDragSystem() {
            const vm = this;
            const $root = $(this.$el);

            // 先清理 draggable
            $root.find(".drag-item").each(function () {
                const $el = $(this);
                if ($el.hasClass("ui-draggable")) {
                    $el.draggable("destroy");
                }
                $el.off("click.mobileAdd");
                $el.off("click.mobileBack");
                $el.off("dblclick");
            });

            $root.find(".drop-area").each(function () {
                const $el = $(this);
                if ($el.hasClass("ui-droppable")) {
                    $el.droppable("destroy");
                }
            });

            $root.find(".origin-area").each(function () {
                const $el = $(this);
                if ($el.hasClass("ui-droppable")) {
                    $el.droppable("destroy");
                }
            });

            // 记录原始位置：用 position()，不用 css('left')
            $root.find(".origin-area .drag-item").each(function () {
                const $item = $(this);
                
                if (
                    $item.data("origin-left") == null ||
                    $item.data("origin-left") == '' ||
                    $item.data("origin-left") == '0'
                ) {
                    $item.data("origin-left", $item.position().left);
                    $item.data("origin-top", $item.position().top);
                }

                $item.data("in-drop", false);
                $item.data("slot-index", "");
            });

            // ===== 移动端：改成点击逻辑 =====
            if (this.isMobile) {
                this.bindMobileClickEvents();
                this.refreshRuleState();
                return;
            }

            // ===== PC端：保留拖拽逻辑 =====
            vm.initDraggable($root.find(".drag-item"));

            // 拖入区域
            $root.find(".drop-area").droppable({
                accept: ".drag-item",
                hoverClass: "hover-active",

                drop(event, ui) {
                    const $dropArea = $(this);
                    const $item = ui.draggable;

                    const isIniu = $item.hasClass("iniu-item");
                    const normalCount = vm.getSelectedNormalItems().length;
                    const alreadyInDrop = !!$item.data("in-drop");

                    // 普通物品限制：最多5个
                    if (!isIniu && !alreadyInDrop && normalCount >= vm.maxNormal) {
                        $item.animate({
                            left: $item.data("origin-left"),
                            top: $item.data("origin-top")
                        }, 200);
                        return;
                    }

                    // INIU：满5个后两个都能选
                    if (isIniu && !alreadyInDrop) {
                        if (normalCount < vm.maxNormal) {
                            $item.animate({
                                left: $item.data("origin-left"),
                                top: $item.data("origin-top")
                            }, 200);
                            return;
                        }

                        // 只允许带入一个 INIU
                        const iniuCount = $dropArea.children(".iniu-item").length;
                        if (iniuCount >= 1) {
                            $item.animate({
                                left: $item.data("origin-left"),
                                top: $item.data("origin-top")
                            }, 200);
                            return;
                        }
                    }

                    vm.moveItemToDrop($item, ui);
                }
            });

            // 原始区域
            $root.find(".origin-area").droppable({
                accept: ".drag-item",
                drop(event, ui) {
                    vm.moveToOrigin(ui.draggable);
                }
            });

            this.refreshRuleState();
        },
        bindMobileClickEvents() {
            const vm = this;
            const $root = $(this.$el);

            // 商品池里的点击加入
            $root.find(".origin-area .drag-item").each(function () {
                const $item = $(this);

                $item.off("click.mobileAdd").on("click.mobileAdd", function () {
                    vm.handleMobileItemClick($(this));
                });
            });

            // bag 里的点击返回
            $root.find(".drop-area .drag-item").each(function () {
                const $item = $(this);

                $item.off("click.mobileBack").on("click.mobileBack", function () {
                    vm.moveToOrigin($(this));
                });
            });
        },
        handleMobileItemClick($item) {
            const isIniu = $item.hasClass("iniu-item");
            const normalCount = this.getSelectedNormalItems().length;
            const $root = $(this.$el);
            const $dropArea = $root.find(".drop-area");
        
            // 普通物品最多 5 个
            if (!isIniu && normalCount >= this.maxNormal) {
                return;
            }
        
            // INIU：只要满5个后，两个都可选
            if (isIniu) {
                if (normalCount < this.maxNormal) {
                    return;
                }
        
                const iniuCount = $dropArea.children(".iniu-item").length;
                if (iniuCount >= 1) {
                    return;
                }
            }
        
            this.moveItemToDrop($item, null);
        },
        moveItemToDrop($item, ui) {
            const $root = $(this.$el);
            const $dropArea = $root.find(".drop-area");
        
            // ===== 移动端：使用固定位置，并自动找空位 =====
            if (this.isMobile) {
                const positions = [
                    { left: '1%', top: '3%' },
                    { left: '32%', top: '4%' },
                    { left: '65%', top: '3%' },
                    { left: '2%', top: '32%' },
                    { left: '66%', top: '38%' },
                    { left: '36%', top: '34%' } // 第6个 INIU
                ];
        
                let slotIndex = $item.data("slot-index");
        
                // 如果当前元素还没有槽位，就找一个空槽位
                if (slotIndex === undefined || slotIndex === null || slotIndex === '') {
                    const usedSlots = [];
        
                    $dropArea.children(".drag-item").each(function () {
                        const used = $(this).data("slot-index");
                        if (used !== undefined && used !== null && used !== '') {
                            usedSlots.push(Number(used));
                        }
                    });
        
                    slotIndex = positions.findIndex((_, idx) => !usedSlots.includes(idx));
        
                    // 如果没找到空位，就兜底用最后一个
                    if (slotIndex === -1) {
                        slotIndex = positions.length - 1;
                    }
        
                    $item.data("slot-index", slotIndex);
                }
        
                const pos = positions[slotIndex] || positions[positions.length - 1];
        
                $item.appendTo($dropArea).css({
                    position: "absolute",
                    left: pos.left,
                    top: pos.top,
                    zIndex: 3
                });
            }
            // ===== PC端：使用拖拽落点 =====
            else {
                if (!ui) return;
        
                const offset = $dropArea.offset();
                const x = ui.offset.left - offset.left;
                const y = ui.offset.top - offset.top;
        
                $item.appendTo($dropArea).css({
                    position: "absolute",
                    left: x,
                    top: y,
                    zIndex: 3
                });
            }
        
            $item.data("in-drop", true);
        
            if ($item.hasClass("iniu-item")) {
                if ($item.hasClass("INIU_P50")) {
                    this.recommendedIniu = "INIU_P50";
                } else if ($item.hasClass("INIU_P73")) {
                    this.recommendedIniu = "INIU_P73";
                }
            }
        
            // PC：双击返回
            if (!this.isMobile) {
                $item.off("dblclick").on("dblclick", () => {
                    this.moveToOrigin($item);
                });
            }
        
            // Mobile：点击返回
            if (this.isMobile) {
                $item.off("click.mobileBack").on("click.mobileBack", () => {
                    this.moveToOrigin($item);
                });
            }
        
            this.refreshRuleState();
        
            if (this.isMobile) {
                this.$nextTick(() => {
                    this.bindMobileClickEvents();
                });
            }
        },
        //复原
        resetBag() {
            const $root = $(this.$el);
            const vm = this;
        
            const $dropItems = $root.find(".drop-area .drag-item");
            const $originArea = $root.find(".origin-area");
        
            // 1. 清空推荐/已选状态
            this.suggestedIniu = "";
            this.recommendedIniu = "";
            this.hasDroppedIniu = false;
        
            //localStorage.removeItem("recommendedIniu");
        
            // 2. 把包里的所有商品移回商品池
            $dropItems.each(function () {
                const $item = $(this);
        
                $item.appendTo($originArea);
        
                if (vm.isMobile) {
                    // 移动端：恢复默认流式布局
                    $item.css({
                        position: "",
                        left: "",
                        top: "",
                        zIndex: "",
                        opacity: "",
                        pointerEvents: "",
                        display: ""
                    });
                } else {
                    // PC端：恢复初始 absolute 位置
                    $item.css({
                        position: "absolute",
                        left: $item.data("origin-left") + "px",
                        top: $item.data("origin-top") + "px",
                        zIndex: 1,
                        opacity: "",
                        pointerEvents: "",
                        display: ""
                    });
                }
        
                $item.data("in-drop", false);
                $item.off("dblclick");
                $item.off("click.mobileBack");
            });
        
            // 3. 清理样式状态
            $root.find(".origin-area .iniu-item")
                .removeClass("iniu-active iniu-suggested")
                .css({
                    opacity: 0.35,
                    pointerEvents: "none",
                    display: ""
                });
        
            $root.find(".origin-area .drag-item").not(".iniu-item").css({
                opacity: 1,
                pointerEvents: "auto",
                display: ""
            });
        
            // 5. 刷新规则和事件
            this.refreshRuleState();
        
            if (this.isMobile) {
                this.$nextTick(() => {
                    this.bindMobileClickEvents();
                });
            }
        },
        returnNav(){
            this.resetBag()
            this.navIndex = 0
        },
        initDraggable($elements) {
            const vm = this;

            $elements.draggable({
                helper: "original",
                revert: "invalid",
                cursor: "move",

                start() {
                    $(this).css({
                        position: "absolute",
                        zIndex: vm.zIndexNum++
                    });
                }
            });
        },

        //移出物品
        moveToOrigin($item) {
            const $root = $(this.$el);
            const $originArea = $root.find(".origin-area");
        
            if (this.isMobile) {
                $item.appendTo($originArea).css({
                    position: "",
                    left: "",
                    top: "",
                    zIndex: ""
                });
            } else {
                $item.appendTo($originArea).css({
                    position: "absolute",
                    left: $item.data("origin-left") + "px",
                    top: $item.data("origin-top") + "px",
                    zIndex: 1
                });
            }
        
            $item.data("in-drop", false);
            $item.data("slot-index", ""); // 释放槽位
            $item.off("dblclick");
            $item.off("click.mobileBack");
        
            if ($item.hasClass("iniu-item")) {
                this.recommendedIniu = "";
            }
        
            this.refreshRuleState();
        
            if (this.isMobile) {
                this.$nextTick(() => {
                    this.bindMobileClickEvents();
                });
            }
        },

        // 获取当前已选中的“普通物品”
        getSelectedNormalItems() {
            const $root = $(this.$el);
            return $root.find(".drop-area .drag-item").not(".iniu-item").toArray();
        },

        // 统计前5件普通物品
        getSelectionStats() {
            const items = this.getSelectedNormalItems();

            let totalVolume = 0;
            let slimCount = 0;

            items.forEach((el) => {
                const classList = Array.from(el.classList);
                const key = classList.find(cls => this.itemMeta[cls]);

                if (key && this.itemMeta[key]) {
                    totalVolume += this.itemMeta[key].volume || 0;
                    if (this.itemMeta[key].shape === "Slim") {
                        slimCount++;
                    }
                }
            });

            return {
                totalVolume,
                slimCount,
                count: items.length
            };
        },

        // 按规则计算推荐哪个 INIU
        getRecommendedIniu() {
            const stats = this.getSelectionStats();

            // 必须普通物品达到5件后才开始判断
            if (stats.count < 5) return "";

            if (stats.totalVolume > 70) {
                return "INIU_P50";
            }

            if (stats.totalVolume <= 70 && stats.slimCount >= 3) {
                return "INIU_P73";
            }

            return "INIU_P50";
        },
        refreshRuleState() {
            const $root = $(this.$el);
            const stats = this.getSelectionStats();
            const suggested = this.getRecommendedIniu();
        
            // 系统推荐，仅用于提示
            this.suggestedIniu = suggested;
        
            // 是否已经拖入了 INIU
            this.hasDroppedIniu = $root.find(".drop-area .iniu-item").length > 0;
        
            // ===== tips =====
            if ($root.find(".drop-area .drag-item").length > 0) {
                $root.find(".box2_tips").css({ opacity: 0 });
            } else {
                $root.find(".box2_tips").css({ opacity: 1 });
            }
        
            // ===== 普通商品 =====
            const $normalItems = $root.find(".origin-area .drag-item").not(".iniu-item");
        
            if (stats.count >= this.maxNormal) {
                if (this.isMobile) {
                    // 移动端：直接隐藏
                    $normalItems.css({
                        display: "none"
                    });
                } else {
                    // PC：灰掉
                    $normalItems.css({
                        opacity: 0.4,
                        pointerEvents: "none",
                        display: ""
                    });
                }
            } else {
                // 恢复
                $normalItems.css({
                    opacity: 1,
                    pointerEvents: "auto",
                    display: ""
                });
            }
        
            // ===== INIU 商品 =====
            const $iniuItems = $root.find(".origin-area .iniu-item");
        
            // 默认：未满5个 → 全灰不可选
            $iniuItems.css({
                opacity: 0.35,
                pointerEvents: "none",
                display: ""
            }).removeClass("iniu-active iniu-suggested");

            // 满5个后
            if (stats.count >= this.maxNormal) {

                // 如果用户还没选 INIU → 两个都可选
                if (!this.hasDroppedIniu) {
                    $iniuItems.css({
                        opacity: 1,
                        pointerEvents: "auto"
                    });
                }

                // ✅ 如果已经选了一个 INIU
                else {
                    const selected = this.recommendedIniu;

                    // 所有先禁用
                    $iniuItems.css({
                        opacity: 0.35,
                        pointerEvents: "none"
                    });

                    // 选中的那个恢复正常
                    if (selected) {
                        $root.find(".origin-area ." + selected).css({
                            opacity: 1,
                            pointerEvents: "auto"
                        })
                    }
                }
            }
        },
        handleResize() {
            const newIsMobile = window.innerWidth <= 768;

            if (newIsMobile !== this.isMobile) {
                this.isMobile = newIsMobile;

                this.$nextTick(() => {
                    this.initDragSystem();
                });
            }
        },
        //拖拽完成 提交
        handleSubmit() {
            const $root = $(this.$el);
            const $items = $root.find(".drop-area .drag-item");

            if ($items.length === 0) {
                return showMessage('Please select an item first.', 'error');
            }

            const hasINIU = $root.find(".drop-area .iniu-item").length > 0;

            if (!hasINIU) {
                return showMessage("Oh dear, it's not finished yet.", 'error');
            }

            localStorage.setItem('recommendedIniu', this.recommendedIniu);
            this.setCode()
            this.captureBox()
            setTimeout(() => {
                this.resFlag = true
            }, 100);
        },
        setCode(){
            this.iniuData = localStorage.getItem('recommendedIniu') || ''
            if(this.iniuData == 'INIU_P73'){
                $('.P73_CODE').css({opacity:'1'})
            }else if(this.iniuData == 'INIU_P50'){
                $('.P50_CODE').css({opacity:'1'})
            }
        }
    },
    mounted() {
        this.isMobile = window.innerWidth <= 768;

        this.setCode()

        if (this.isMobile) {
            this.tips = 'Tap up to 5 items to add them into the bag! Tap again to remove.';
        }
    
        window.addEventListener('resize', this.handleResize);

        var wFlag = window.innerWidth > 750

        this.$nextTick(() => {
            this.initDragSystem();
        });
        new Swiper('.box2Swiper', {
            navigation: {
                nextEl: '.box2Swiper-button-next',
                prevEl: '.box2Swiper-button-prev',
            },
        })

        //box3
        if (!wFlag) {
            new Swiper('.box3Swiper1', {
                autoplay: true,
            })
            new Swiper('.box3Swiper2', {
                autoplay: true,
            })
        }
    }
})
